import React from "react";
import { Check, Package, Truck, IndianRupee, Boxes } from "lucide-react";
import { useSEO } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { PageHero } from "@/components/PageBits";
import LeadForm from "@/components/LeadForm";

const SEGMENTS = ["Hotels", "Restaurants", "Tea Shops", "Corporate Offices", "Hospitals", "Educational Institutions"];
const PERKS = [
  { icon: Package, t: "Custom Packaging", d: "Your brand, your pack sizes — fully customizable." },
  { icon: Truck, t: "Fast Dispatch", d: "Quick, reliable delivery across India." },
  { icon: IndianRupee, t: "Competitive Pricing", d: "Wholesale rates that protect your margins." },
  { icon: Boxes, t: "Flexible MOQ", d: "Order quantities that suit your scale." },
];

export default function BulkOrders() {
  useSEO({ title: "Bulk Tea Supply Across India", description: "Leaf Alchemy specializes in bulk tea powder supply for hotels, restaurants, tea shops, hospitals and offices with custom packaging and fast dispatch." });

  return (
    <div data-testid="bulk-orders-page">
      <PageHero eyebrow="Wholesale & Bulk" title="Bulk Tea Supply Across India"
        image="https://images.unsplash.com/photo-1714125953083-c363fb45696b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000"
        subtitle="We specialize in bulk tea powder supply with custom packaging, fast dispatch and competitive pricing." />

      <section className="py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-16">
          <div>
            <Reveal>
              <h2 className="font-display text-3xl text-forest">Built for Volume Buyers</h2>
              <p className="text-muted-foreground mt-4">We supply premium tea powder in bulk to businesses of every scale. Whatever your requirement, we tailor the blend, pack size and pricing to fit.</p>
              <div className="grid sm:grid-cols-2 gap-4 mt-8">
                {SEGMENTS.map((s) => (
                  <div key={s} className="flex items-center gap-3 bg-cream border border-forest/10 rounded-xl px-4 py-3">
                    <Check className="text-olive" size={18} /> <span className="text-forest font-medium text-sm">{s}</span>
                  </div>
                ))}
              </div>
              <div className="grid sm:grid-cols-2 gap-6 mt-10">
                {PERKS.map((p) => (
                  <div key={p.t} className="flex gap-4">
                    <div className="w-11 h-11 rounded-xl bg-forest/10 grid place-items-center text-forest shrink-0"><p.icon size={20} /></div>
                    <div>
                      <h4 className="font-display text-lg text-forest">{p.t}</h4>
                      <p className="text-sm text-muted-foreground">{p.d}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <div className="bg-cream border border-gold/30 rounded-2xl p-7 shadow-[0_16px_48px_rgba(15,81,50,0.08)] lg:sticky lg:top-28" data-testid="bulk-form-card">
              <h3 className="font-display text-2xl text-forest mb-1">Get a Bulk Quote</h3>
              <p className="text-sm text-muted-foreground mb-5">Tell us your requirement — we&rsquo;ll respond within 24 hours.</p>
              <LeadForm type="bulk" fields={["name", "phone", "email", "company", "business_type", "product", "quantity", "message"]} submitLabel="Get Bulk Quote" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
